module.exports = __webpack_public_path__ + "fonts/02cee8d.otf";